/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Questiontext1Inputs */

const en__field_questiontext1 = /** @type {(inputs: _Field_Questiontext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question text`)
};

/**
* | output |
* | --- |
* | "Question text" |
*
* @param {_Field_Questiontext1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_questiontext1 = /** @type {((inputs?: _Field_Questiontext1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Questiontext1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_questiontext1(inputs)
});
export { _field_questiontext1 as "_field_questionText" }